import { coreApi as api } from "../core/BaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiLogs: build.query<GetApiLogsApiResponse, GetApiLogsApiArg>({
      query: (queryArg) => ({
        url: `/api/Logs`,
        params: { date: queryArg.date },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiLogsApiResponse = unknown;
export type GetApiLogsApiArg = {
  date?: string;
};
export const { useGetApiLogsQuery, useLazyGetApiLogsQuery } = injectedRtkApi;
